import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50 hover:bg-primary-100', text: 'text-primary-500', iconBg: 'bg-primary-100' },
  accent: { bg: 'bg-accent-50 hover:bg-accent-100', text: 'text-accent-500', iconBg: 'bg-accent-100' },
  secondary: { bg: 'bg-secondary-50 hover:bg-secondary-100', text: 'text-secondary-500', iconBg: 'bg-secondary-100' },
};

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            <a href="#category-nav" className="hover:text-primary-500 transition-colors">分类浏览</a>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            从不同维度深入了解《玉蒲团》，选择您感兴趣的研究方向
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group ${colors.bg} rounded-lg p-5 md:p-6 transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-10 h-10 ${colors.iconBg} rounded-md flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-200`}>
                  <i className={`${cat.icon} text-lg ${colors.text}`}></i>
                </div>
                <h3 className={`text-base md:text-lg font-semibold ${colors.text} mb-1.5`}>
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}